"use strict";

import c from "magic-string";
var r = "\u200B";

function x(t) {
  return t.join(r);
}

function l(t) {
  return t === r ? "" : t.replace(/\u200b+/gm, r).replace(/\u200b+$/gm, "").replace(/^\u200b+/gm, "");
}

function a(t) {
  return t.replace(/\u200b*/gm, "");
}

function m(t) {
  var i = /[\u1780-\u17ff]+/gm,
      e,
      n = [];

  for (; e = i.exec(t);) {
    if (!e) continue;
    var o = e[0];
    n.push({
      start: e.index,
      end: e.index + o.length,
      value: o
    });
  }

  return n;
}

function d(t) {
  var i = a(l(t)),
      e = m(i),
      n = new c(i),
      o = new Intl.Segmenter("km", {
    granularity: "word"
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var s = _step.value;
      var u = Array.from(o.segment(s.value)).map(function (g) {
        return g.segment;
      }).join(r);
      n.overwrite(s.start, s.end, u);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return n.toString().split(r);
}

export { x as joinToString, l as normalize, a as sanitize, d as split, m as tokenize };